import React from 'react';
import { NftUtilityContainer } from './NftUtilityContainer';
export const NftUtilityView = () => {
  return (
    <>
      <NftUtilityContainer />
    </>
  );
};
